import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/react-native/next/app/(main)/(functional)/error.tsx");
